import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fFecha } from 'src/app/core/Funciones/fFecha';
import { mostrarSwalError } from 'src/app/core/Funciones/funciones';
import { AccesoDatosService } from 'src/app/core/services/acceso-datos.service';
import { PDFService } from 'src/app/core/services/pdfmake.service';
import { EmpleadosContratos, IRespuestaContratos, TipoContratos } from 'src/app/models/documentos';
import { Contrato, IEmpleados, nombreEmpleado, TipoEmpleado } from 'src/app/models/empleados';
import { Estados, IEmpresa } from 'src/app/models/empresa';
import { DatosIncidencias } from 'src/app/models/incidencias';
const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-empleados-acta-administrativa',
  templateUrl: './empleados-acta-administrativa.component.html',
  styleUrls: ['./empleados-acta-administrativa.component.scss']
})
export class EmpleadosActaAdministrativaComponent implements OnInit {
  public estaCargando: boolean = true;
  public esDebugger: boolean = false;
  public empleados: IEmpleados[] = [];
  public empleadosRepresentantes: IEmpleados[] = [];
  public empresa!: IEmpresa;
  public leyenda: string = '';
  public cuerpoActa: Contrato = new Contrato();
  public nombresUpper: boolean = false;
  public empleadoRepresentanteSeleccionado?: IEmpleados;
  public empleadoTestigo1?: IEmpleados;
  public empleadoTestigo2?: IEmpleados;
  public empleadoSeleccionado?: IEmpleados;
  public fechaFalta: string = '';
  public estados = Estados;

  constructor(
    private accesoDatosService: AccesoDatosService,
    public dialogRef: MatDialogRef<EmpleadosActaAdministrativaComponent>,
    private pdfService: PDFService,
    @Inject(MAT_DIALOG_DATA) public data?: { incidencia: DatosIncidencias },
  ) {
    this.cargarDatos();
  }

  public cargarDatos() {
    this.estaCargando = true;
    this.esDebugger = this.accesoDatosService.getModoDebug();
    let datosActa: EmpleadosContratos = new EmpleadosContratos();
    datosActa.tipoContrato = TipoContratos.ActaAdministrativa;

    this.accesoDatosService.contratosObtener(datosActa).subscribe(
      (respuesta: IRespuestaContratos) => {
        if (!respuesta.empresa) {
          mostrarSwalError(`Contratos`, `Error al cargar los datos de los contratos desde el servidor. Código: ${respuesta.code}, ${respuesta.mensaje}`);
          return;
        }
        this.cargarEmpleados();
        this.empresa = respuesta.empresa;
        if (!!respuesta.data) {
          this.leyenda = respuesta.data;
          this.cuerpoActa.leyenda = respuesta.data;
        }
        if (!this.cuerpoActa.leyenda) {
          this.accesoDatosService.actaAdministrativaPredeterminada().subscribe(
            (leyenda: string) => {
              this.leyenda = leyenda;
              this.cuerpoActa.leyenda = leyenda;
            }
          );
        }
        this.estaCargando = false;
      },
      (error: HttpErrorResponse) => {
        console.log(`Conectando con el servidor. Contrato obtener. Error.`);
        let err: string = JSON.stringify(error);
        console.log(err);
        mostrarSwalError(`Contratos`, `Error al cargar los datos de los contratos desde el servidor. Código: ${err}`);
      },
    );
  }

  public cargarEmpleados() {
    this.accesoDatosService.empleadosListado().subscribe(
      (empleados: IEmpleados[]) => {
        this.empleados = empleados;
        this.empleados.forEach(empleado => {
          (empleado as any)['nombreCompleto'] = `${empleado.nombre} ${empleado.paterno ? empleado.paterno : ''} ${empleado.materno ? empleado.materno : ''}`;
        });
        if (this.data) {
          this.empleadoSeleccionado = this.empleados.find(e => this.nombreCompleto(e).toLowerCase().trim() === this.data!.incidencia.nombre.toLowerCase().trim());
        }
        this.aplicarFiltros();
      },
      (error) => {
        this.accesoDatosService.logAgrega2("Error al cargar los datos de los empleados");
        console.error(error);
        this.empleados = [];
      }
    );
  }

  public aplicarFiltros() {
    this.empleados = this.empleados.filter(x => !x.baja || x.baja.getTime() <= new Date(1900, 1, 1).getTime()).sort(
      (a, b) => +a.numero - +b.numero || a.nombre?.toLowerCase().localeCompare(b.nombre?.toLowerCase())
    );

    this.empleadosRepresentantes = this.empleados.filter(x => x.tipoEmpleado !== TipoEmpleado.Normal);
  }

  public nombreCompleto(empleado: IEmpleados): string {
    if (this.nombresUpper) {
      return nombreEmpleado(empleado).toUpperCase();
    } else {
      return nombreEmpleado(empleado);
    }
  }

  private generarHoraAleatoria(): Date {
    const opciones = [
      new Date(2025, 1, 1, 10, 0, 0),
      new Date(2025, 1, 1, 9, 15, 0)
    ];
    return opciones[Math.floor(Math.random() * opciones.length)];
  }

  public async exportarPDF() {
    if (!this.empleadoRepresentanteSeleccionado || !this.empleadoTestigo1 || !this.empleadoTestigo2 || !this.empleadoSeleccionado || !this.fechaFalta) {
      mostrarSwalError('Error', 'Favor de seleccionar a los empleados representantes, testigos, nombre del empleado y la fecha de la falta');
      return;
    }

    try {
      const { empresaImageBase64, logoAcceso } = await this.pdfService.obtenerImg(this.empresa);

      const docDefinition: any = {
        pageOrientation: 'portrait',
        pageSize: 'letter',
        footer: (currentPage: number, pageCount: number) => {
          return {
            columns: [
              { text: `Página ${currentPage} de ${pageCount}`, alignment: 'center', style: 'footer' },
              { image: logoAcceso, width: 50, alignment: 'right' }
            ],
            margin: [0, 10, 10, 0],
          };
        },
        content: [],
        styles: {
          footer: { fontSize: 10, italics: true, margin: [0, 0, 0, 10] },
          firmaEmpleado: { color: '#343a40', fontSize: 10 },
          titulo: { bold: true, fontSize: 15 },
        }
      }

      const horas = this.generarHoraAleatoria();
      const fechaFaltaStr = new Date(this.fechaFalta);
      const empleadoSection = [
        {
          columns: [
            { image: empresaImageBase64, width: 50, margin: [0, 0, 20, 0] },
            { text: 'ACTA ADMINISTRATIVA POR FALTAS', style: 'titulo', alignment: 'center', margin: [0, 10, 0, 0] },
          ]
        },
        {
          margin: [0, 20, 0, 0],
          text: this.cuerpoActa.leyenda.replace(/{domicilioNumero}/g, () => {
          const domicilio = this.empresa?.domicilio || '';
          const numeroMatch = domicilio.match(/\d+/);
          const numVerify = numeroMatch ? numeroMatch[0] : '-'
          const numeroString = this.convertirString(+numVerify);
          const numeroConvertido = `${numeroMatch} ${numeroString}`;
          return numeroConvertido;
          }).replace(/{domicilioCalle}/g, () => {
            const domicilio = this.empresa?.domicilio || '';
            const calle = domicilio.replace(/\d+/, '').trim();
            return calle || '-';
          }).replace(/{domicilioColonia}/g, '-')
          .replace(/{domicilioCiudad}/g, `${this.empresa.ciudad}`)
          .replace(/{domicilioEstado},/g, () => {
            const estadoKey = this.empresa?.estado as keyof typeof Estados;
            const estado = this.estados[estadoKey] || '-';
            return estado;
          })
          .replace(/{domicilioCP}/g, `${this.empresa.cp}`)
          .replace(/{cpConvertido}/g, `${this.convertirString(+this.empresa.cp, ' ')}`)
          .replace(/{hora}/g, `${this.formatoFecha(horas, 'hm')}`)
          .replace(/{fechaFalta}/g, `${this.formatoFecha(fechaFaltaStr, 'fa2')}`)
          .replace(/{nombreRepresentanteLegal}/g, `${this.nombreCompleto(this.empleadoRepresentanteSeleccionado)}`)
          .replace(/{nombreEmpresa}/g, `${this.empresa.nombre}`)
          .replace(/{nombreEmpleadoFalta}/g, `${this.nombreCompleto(this.empleadoSeleccionado)}`)
          .replace(/{testigo1}/g, `${this.nombreCompleto(this.empleadoTestigo1)}`)
          .replace(/{testigo2}/g, `${this.nombreCompleto(this.empleadoTestigo2)}`)
          .replace(/{testigo1Puesto}/g, `${this.empleadoTestigo1.puesto}`)
          .replace(/{testigo2Puesto}/g, `${this.empleadoTestigo2.puesto}`)
          .replace(/{horaConvertida}/g, () => {
            const horaFormateada = this.formatoFecha(horas, 'hm');
            const horaString = this.convertirHoraString(horaFormateada);
            return horaString;
          })
        },
        {
          table: {
            widths: ['*', '*'],
            body: [
              [
                this.firmaField(this.empleadoRepresentanteSeleccionado),
                this.firmaField(this.empleadoSeleccionado)
              ],
              [
                this.firmaField(this.empleadoTestigo1),
                this.firmaField(this.empleadoTestigo2)
              ]
            ]
          },
          layout: 'noBorders',
          margin: [0, 10, 0, 0]
        }
      ];
      docDefinition.content.push(...empleadoSection);
      pdfMake.createPdf(docDefinition).download(`Acta_administrativa.pdf`);
    } catch (error) {
      console.error('Error al generar el PDF', error);
    }
  }

  public firmaField(persona: IEmpleados) {
    return {
      stack: [
        {
          canvas: [{ type: 'line', x1: 0, y1: 10, x2: 200, y2: 10, lineWidth: 1.5 }],
          width: 100,
          margin: [0, 20, 0, 2]
        },
        { text: `${this.nombreCompleto(persona)}`, bold: true, style: 'firmaEmpleado' },
        { text: 'Firma', bold: true, style: 'firmaEmpleado' }
      ],
      alignment: 'center'
    };
  }

  public convertirString(num: number, separador: string = ' y '): string {
    return num.toString().split('').map(digit => this.obtenerString(+digit)).join(separador);
  }

  private obtenerString(num: number): string {
    const palabras: { [key: number]: string } = {
      0: 'cero', 1: 'uno', 2: 'dos', 3: 'tres', 4: 'cuatro',
      5: 'cinco', 6: 'seis', 7: 'siete', 8: 'ocho', 9: 'nueve',
      10: 'diez', 11: 'once', 12: 'doce', 13: 'trece', 14: 'catorce', 15: 'quince',
    };
    return palabras[num] || '';
  }

  private convertirHoraString(hora: string): string {
    const [horas, minutos] = hora.split(':').map(Number);
    const horasString = this.obtenerString(horas);
    if (minutos === 0) {
      return `${horasString} horas`;
    }
    const minutosString = this.obtenerString(minutos);
    return `${horasString} horas ${minutosString} minutos`;
  }

  public formatoFecha(fecha: Date | undefined, formato: string) {
    if (!fecha) {
      return '-';
    }
    return fFecha(fecha, formato);
  }

  ngOnInit(): void {
    if (this.data) {
      this.fechaFalta = this.data?.incidencia.fecha?.toISOString().split('T')[0] ?? '';
    }
  }
}
